<template>
  <table class="" style="width: 100%">
    <template v-if="topDocument && topDocument.publication === 'internal'">
      <internal-author-top v-model="author"></internal-author-top>
    </template>

    <tr v-else :class="{selected: author.selected}">
      <template v-if="context.name === 'expertResult'">

        <td class="col-md-2 col-xs-2" style="vertical-align: middle;" id="expert">
          {{ author.lastName }}, {{ author.firstName }} <template v-if="$env !== 'production'">({{author.docs.length}}) ({{author.score}})</template>
        </td>

        <td class="col-md-3 col-xs-3 " style="vertical-align: middle" id="country-affiliation">
          <table class="table" style="width: 100%;">
            <td class="col-xs-4 col-md-4 text-center" style="vertical-align: middle">
              <flag v-if="author.affiliation && author.affiliation.organisationID" :squared="false" :iso="getIso(author.affiliation)" style="height: 100%"/>
            </td>
            <td class="col-md-8 col-xs-8 "  v-if="author.affiliation && author.affiliation.organisationID" style="">{{author.affiliation.organisationName | truncate(50)}}</td>
          </table>
        </td>

        <template v-if="topDocument">
          <td class="col-md-4 col-xs-4" id="top-document-title" v-html="topDocument.title"></td>
        </template>
        <template v-else>
          <td class="col-md-4 col-xs-4" id="top-document-title"></td>
        </template>

        <td class="col-md-1 col-xs-1 text-center" id="expert-score" style="vertical-align: center">
          <select :id="'score-'+ this.author.authorID" v-if="topDocument">
            <option value="3">3</option>
            <option value="2">2</option>
            <option value="1">1</option>
          </select>
        </td>
        <td class="col-md-1 col-xs-1 text-center" style="vertical-align: middle;" ref="actions">
          <i v-if="author.followSearchId !== null" class="fas fa-star text-info" data-toggle="popover" :data-content="'Monitored expert'"></i>
          <span class="label label-info" v-if="hasNewDocument() === true" data-toggle="popover" :data-content="'Update(s) on your monitored query'">New</span>
          <span data-toggle="popover"
                data-content="Expert having declared him/herself competent on your query and available for contact"
                class="text-info" v-if="author.localExpert"> &#9424; </span>

        </td>
        <td class="col-md-1 col-sm-1 text-center" style="vertical-align: middle" id="expert-action">
          <dropdown-author v-model="author" :context="context"></dropdown-author>
        </td>
      </template>
      <template v-else>
        <td class="col-md-2 col-lg-2 col-xl-1 text-center visible-md visible-lg visible-xl">
          <div class="checkbox checkbox-info">
            <input type="checkbox" @click="checked" v-model="author.checked">
            <label></label>
          </div>
        </td>
        <td class="col-xs-4 col-md-3 col-lg-1 col-xl-2" style="vertical-align: middle" >
          {{ author.lastName }}, {{ author.firstName }}
        </td>

        <td class="col-xs-6 col-md-5 col-lg-3 col-xl-3" style="vertical-align: middle" >
          <table class="table" style="width: 100%;">
            <td class="col-xs-5 col-md-5 text-center" style="vertical-align: middle">
              <flag v-if="author.affiliation && author.affiliation.organisationID" :squared="false" :iso="getIso(author.affiliation)" style="height: 100%"/>
            </td>
            <td class="col-xs-7 col-md-7" v-if="author.affiliation && author.affiliation.organisationID" style="">{{author.affiliation.organisationName | truncate(50)}}</td>
          </table>
        </td>

        <template v-if="topDocument">
          <td class="col-lg-4 col-xl-4 visible-lg visible-xl" v-html="topDocument.title"></td>
        </template>
        <template v-else>
          <td class="col-lg-4 col-xl-4 visible-lg visible-xl"></td>
        </template>
        <td class="col-lg-1 col-xl-1 visible-lg visible-xl text-center" style="vertical-align: middle;" ref="actions">
          <i v-if="author.followSearchId !== null" class="fas fa-star text-info" data-toggle="popover" :data-content="'Monitored expert'"></i>
        </td>

        <td class="col-xs-2 col-md-2 col-lg-1 col-xl-1 text-center" style="vertical-align: center">
          <dropdown-author v-model="author" :context="context"></dropdown-author>
        </td>
      </template>
    </tr>

  </table>

</template>

<style scoped>

.selected {
  border-left: 5px solid #3498db;
}

.dropdown-menu {
  min-width: 50px;
}
div > .dropdown > i {
  cursor: pointer;
}

.dropdown-expert-action > ul > li i{
  font-weight: bold;
  margin-right: 5px;
}

.dropdown-expert-action ul > li a{
  font-size: 12px;
}

.dropdown-expert-action ul > li{
  margin-bottom: 5px;
  font-size: 12px;
}
</style>
<style>
.br-theme-bars-horizontal .br-widget a {
  height: 10px;
  background-color: rgba(0, 123, 225, 0.3);
}

.br-theme-bars-horizontal .br-widget a.br-active, .br-theme-bars-horizontal .br-widget a.br-selected {
  background-color: #007bff;
}
</style>
<script>
import 'jquery-bar-rating/dist/jquery.barrating.min'
import IsoCountries from 'i18n-iso-countries'
import EnCountries from '../../iconFlag/en'
import 'jquery-bar-rating/dist/themes/bars-horizontal.css'
import DropdownAuthor from './DropdownAuthor'
import AuthorSETop from './AuthorSETop'
import InternalAuthorTop from './InternalAuthorTop'

IsoCountries.registerLocale(EnCountries)

export default {
  components: {InternalAuthorTop, AuthorSETop, DropdownAuthor},
  name: 'AuthorTop',
  props: ['value', 'context'],
  data () {
    return {
      author: null,
      topDocument: null
    }
  },
  watch: {
    value: function (val) {
      this.author = val
    },
    author: function (val, oldVal) {
      if (typeof this.$refs.actions !== 'undefined') {
        $(this.$refs.actions).find('[data-toggle="popover"]').popover({
          trigger: 'hover',
          placement: 'top'
        })
      }

      if (oldVal !== null) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    initScore: (author) => {
      let score = 0
      if (author.score <= 0.1) {
        score = 1
      } else if (author.score < 0.5) {
        score = 2
      } else {
        score = 3
      }
      let scoreElement = $('#score-' + author.authorID)

      scoreElement.barrating({
        theme: 'bars-horizontal',
        readonly: true,
        showSelectedRating: false,
        hoverState: false,
        reverse: true,
        initialRating: score
      })
    },
    getIso: (affiliation) => {
      if (typeof affiliation !== 'undefined') {
        let iso = IsoCountries.getAlpha2Code(affiliation.country, 'en')
        if (typeof iso === 'undefined') {
          iso = IsoCountries.toAlpha2(affiliation.code)
        }
        return iso
      }
    },
    checked: function (event) {
      this.$emit('authorChecked', this.author)

      if (typeof event.stopPropagation !== 'undefined') {
        event.stopPropagation()
      }
    },
    hasNewDocument: function () {
      let nexDocument = false
      if (this.author !== null) {
        this.author.docs.forEach((document) => {
          if (document.newDocument === true) {
            nexDocument = true
          }
        })
      }
      return nexDocument
    }
  },
  updated () {
    this.topDocument = this.author.docs[0]
    this.initScore(this.author)
  },
  mounted () {
    this.initScore(this.author)
  },
  beforeMount () {
    this.author = this.value

    this.author.docs.sort(function (doc1, doc2) {
      return new Date(doc2.pubDate) - new Date(doc1.pubDate)
    })

    if (this.context.name === 'expertResult' && typeof this.author.topDocument !== 'undefined' &&
      this.author.topDocument !== null) {
      this.topDocument = this.author.topDocument
    } else if (this.context.name !== 'expertResult') {
      this.topDocument = this.author.docs[0]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/documents/AuthorTop.vue